import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'CustomEditButton',
  standalone: true,
  imports: [
    CommonModule, ButtonModule
  ],
  template: `
    <button pButton icon="pi pi-file-edit" (click)="handleClick($event)"  [disabled]="disabled"
      class="button-edit p-button-outlined"></button>
  `
})
export class CustomEditButton {
  @Input() item !: any;
  @Input() disabled : boolean = false;
  @Output() onClick = new EventEmitter<any>();

  handleClick(event: Event): void {
    this.onClick.emit({ event, item: this.item });
  }
}
